<template>
  <loginHome>
    <div slot="content" class="login-info">
      <div class="login-type">
        <span>找回密码</span>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item prop="tel">
            <el-input v-model="ruleForm.tel" placeholder="请输入手机号" class="login-input">
              <i slot="prefix" class="iconfont icondenglu icon1"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input v-model="ruleForm.code" type="text" placeholder="请输入验证码" class="login-input">
              <i slot="prefix" class="iconfont iconshouji1 icon1"></i>
              <div slot="suffix" class="set-pass" @click="sendCode">{{ codeText }}
                <span v-if="typeof codeText === 'number'">秒后重新发送</span>
              </div>
            </el-input>
          </el-form-item>
          <el-form-item prop="userPass">
            <el-input type="password" v-model="ruleForm.userPass" placeholder="请输入新密码">
              <i slot="prefix" class="iconfont iconicon2 icon1"></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="ruserPass">
            <el-input type="password" v-model="ruleForm.ruserPass" placeholder="请再次输入新密码">
              <i slot="prefix" class="iconfont iconicon2 icon1"></i>
            </el-input>
          </el-form-item>
          <el-button type="primary" class="btnLogin" @click="reguster">找回密码</el-button>
        </el-form>
      </div>
<!--      <div class="login-icons">-->
<!--        <div class="login-icon-t">-->
<!--          <i class="left"></i>-->
<!--          <span>使用其他方式登录</span>-->
<!--          <i class="right"></i>-->
<!--        </div>-->
<!--        <div class="login-img">-->
<!--          <a href="http://yhb.emof.cn/Index/Login/Wechat" class="login-icon-wx">-->
<!--            <i class="iconfont iconicon1"></i>-->
<!--          </a>-->
<!--        </div>-->

<!--      </div>-->
      <div class="no-hao">
        已有帐号，<a href="/login">我要登录</a>
      </div>
    </div>
  </loginHome>
</template>

<script>
import loginHome from './components/box'

export default {
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.userPass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        tel: '',  //  手机号
        code: '',       //  验证码
        userPass: '', // 密码
        ruserPass: '', // 第二遍密码
      },
      rules: {
        tel: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {min: 11, max: 11, message: '请输入正确的手机号', trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {min: 6, max: 6, message: '请输入正确的验证码', trigger: 'blur'}
        ],
        userPass: [
          {validator: validatePass, trigger: 'blur'}
        ],
        ruserPass: [
          {validator: validatePass2, trigger: 'blur'}
        ]
      },
      codeText: '获取验证码', // 验证码文字
      id: null, // 计时器id
      timeId: null, // 一次性计时器id
    }
  },
  created() {

  },
  methods: {

    //  找回密码
    reguster() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '修改中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.$api.apiContent.setPass({
            phone: this.ruleForm.tel,
            code: this.ruleForm.code,
            password: this.$md5(this.ruleForm.userPass),
            repassword: this.$md5(this.ruleForm.ruserPass)
          }).then(() => {
            loading.close();
            this.$message({
              message: '恭喜你，密码已修改，即将跳转登录页。',
              type: 'success'
            })
            this.timeId = setTimeout(() => {
              this.$router.push('/login')
            }, 2000)
          }).catch(e => {
            loading.close();
            this.$message.error(e.msg)
          })
        }
      })
    },
    //  获取验证码
    sendCode() {
      this.$refs.ruleForm2.validateField('tel', (valid) => {
        if (!valid) {
          // 发送ajax
          if (this.codeText === '发送验证码' || this.codeText === '重新发送') {
            this.codeText = 60
            this.id = setInterval(() => {
              if (this.codeText === 0) {
                this.codeText = '重新发送'
                return
              }
              if (typeof this.codeText === 'number') {
                this.codeText--
              }
            }, 1000)
            this.$api.apiContent.getCode({
              phone: this.ruleForm2.tel,
            }).then().catch(e => {
              this.$message.error(e.msg)
              this.codeText = '重新发送'
              clearInterval(this.id)
            })
          }
        }
      })
    }
  },
  components: {
    loginHome
  }
}
</script>

<style scoped lang="scss">
.login-info {
  display: flex;
  flex-direction: column;
  width: 400px;
  height: 560px;
  background-color: #0a2240;
  border-radius: 10px;
  position: relative;
  padding: 45px;
  //margin-right: 150px;
  z-index: 1;

  &:after {
    position: absolute;
    width: 561px;
    height: 357px;
    background: rgba(10, 34, 64, .1);
    border-radius: 10px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    content: '';
    z-index: -1;
  }

  &:before {
    position: absolute;
    width: 489px;
    height: 450px;
    margin: 0 auto;
    background: rgba(10, 34, 64, .3);
    border-radius: 10px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    content: '';
    z-index: -1;
  }
}

.login-type {
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
  margin-bottom: 20px;

  span {
    display: block;
    line-height: 50px;
    font-size: 16px;
    color: #fff;
    position: relative;
    &:before {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 0);
      content: '';
      width: 80px;
      height: 2px;
      background: #fff;
    }
  }
}

.set-pass {
  //background: #fff;
  width: 100px;
  height: 38px;
  margin-top: 6px;
  cursor: pointer;
  font-size: 12px;
  color: #fff;

}

.btnLogin {
  width: 100%;
  height: 48px;
  background-image: linear-gradient(
      37deg, #ffb400, #fc7802), linear-gradient(#0a2240, #0a2240);
  background-blend-mode: normal, normal;
  color: #ffffff;
  font-size: 18px;
  border-radius: 5px;
}

.login-icons {
  height: 85px;
  margin-top: 20px;

  .login-icon-t {
    font-size: 12px;
    color: #999;
    height: 36px;
    text-align: center;
    line-height: 36px;

    .left {
      width: 104px;
      border-bottom: 1px solid #ddd;
      float: left;
      margin-top: 18px;
    }

    .right {
      width: 104px;
      border-bottom: 1px solid #ddd;
      float: right;
      margin-top: 18px;
    }
  }

  .login-img {
    width: 45px;
    margin: 0 auto;

    a.login-icon-wx {
      display: inline-block;
      width: 45px;
      height: 45px;
      background: #13ce66;
      border-radius: 100%;
      text-align: center;
      line-height: 45px;

      i {
        font-size: 30px;
        color: #fff;
      }
    }
  }
}

.no-hao {
  line-height: 28px;
  color: #ffffff44;
  font-size: 12px;
  text-align: right;
  margin-top: 20px;

  a {
    color: #fff;
  }
}

.text1 {
  a {
    color: #0a2240;
  }
}
</style>